import * as React from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import { FormControl, MenuItem, Select, TextField } from '@mui/material'
import { useDispatch } from 'react-redux'
import { getOrganizationCommercialUserType } from '../../../../redux/actions/Organizations'
// import { helpGetUserLoginAccountWithEmail } from '../../../helpers/LoginAccount/helpGetUserLoginAccountWhitEmail'
import useStylesAddUserInOrganization from './Styles/useStylesAddUserInOrganization'
// import { addUserOrganizationCorpEntities } from '../../../helpers/Organization/helpAddUserOfOrganization'
// import { logEvent } from '../../../utils/LogEvents'
import {
  setErrorTextSnackBar,
  setRequestTextSnackBar
} from '../../../../redux/actions/app'
import { getAllTypesUser } from '../../../../redux/actions/User'

export default function StepperAddUserOrganization ({
  setStateUserOrganization,

  item
}) {
  const dispatch = useDispatch()

  const classes = useStylesAddUserInOrganization()

  const [email, setemail] = React.useState('')
  // const [emailerror, setemailerror] = React.useState(false)
  // const [emailerrorText, setemailerrorText] = React.useState('')
  // const [createSuccess, setcreateSuccess] = React.useState(false)
  // const [createFailure, setcreateFailure] = React.useState(false)
  const [emailerror] = React.useState(false)
  const [emailerrorText] = React.useState('')
  const [createSuccess] = React.useState(false)
  const [createFailure] = React.useState(false)
  const [type, settype] = React.useState('')
  const [typeComercial, settypeComercial] = React.useState('')
  const [types, settypes] = React.useState([])
  const [typesComercial, settypesComercial] = React.useState([])

  // get types user
  React.useEffect(async () => {
    const types = await dispatch(getAllTypesUser())
    const typesC = await dispatch(getOrganizationCommercialUserType())
    settypesComercial(typesC.data)
    settypes(types)
  }, [])

  // filter types not derived
  const typesfilter = types.filter((t) => t.organizationUserTypeId !== 2)
  // mock traduc type user in spanish
  // REPLEACE
  const traducSpanishTypeUser = (organizationUserTypeName) => {
    return organizationUserTypeName === 'ORGANIZATION STAFF'
      ? 'Staff'
      : 'Administrador'
  }
  const handleUsernChange = (event) => {
    setemail(event.target.value)
  }
  const handleChangeType = (event) => {
    settype(event.target.value)
  }
  const handleChangeTypeComercial = (event) => {
    settypeComercial(event.target.value)
  }

  // const notUser = async (response) => {
  //   return (
  //     response.response?.data?.codeMessageLanguage ===
  //     'LoginAccountErrorGeneric'
  //   )
  // }

  // const getTypeCode = () => {
  //   return types.find((t) => t.organizationUserTypeName === type)
  //     .organizationUserTypeCode
  // }
  // const getTypeComercialCode = () => {
  //   return typesComercial.find(
  //     (t) => t.organizationCommercialUserTypeName === typeComercial
  //   ).organizationCommercialUserTypeCode
  // }
  // const handlePrepareRequest = (loginAccountId) => {
  //   const body = {
  //     loginAccountId: loginAccountId,
  //     organizationId: item.organizationId,
  //     organizationUserTypeCode: getTypeCode(),
  //     organizationCommercialUserTypeCode: getTypeComercialCode(),
  //     userStatusCode: 'ACTIVE'
  //   }
  //   console.log(body)
  //   return body
  // }
  // const handleValidateAddUserIsFailure = (response) => {
  //   if (response.codeMessageLanguage === 'suborganizationErrorAlreadyExist') {
  //     setemailerror(true)
  //     setemailerrorText('El usuario ya pertenece a la organización')
  //   } else {
  //     setcreateFailure(true)
  //   }
  // }

  // const handleAddUserRequest = async (loginAccountId) => {
  //   const body = handlePrepareRequest(loginAccountId)

  //   try {
  //     const response = await addUserOrganizationCorpEntities(body)

  //     logEvent('CGI - addUserOrganizationCorpEntities', {
  //       body: body,
  //       response: response
  //     })
  //     console.log(response)
  //     setcreateSuccess(true)
  //   } catch (error) {
  //     logEvent('CGI - addUserOrganizationCorpEntities', {
  //       body: body,
  //       error: error
  //     })
  //     console.log(error)
  //     handleValidateAddUserIsFailure(error.response?.data)
  //   }
  // }

  const handleAddUserSubmit = async () => {
    // error
    dispatch(setRequestTextSnackBar())
    dispatch(setErrorTextSnackBar('La funcionalidad está deshabilitada'))

    // try {
    //   const response = await helpGetUserLoginAccountWithEmail(email)
    //   handleAddUserRequest(response.data?.loginAccount?.loginAccountId)
    // } catch (error) {
    //   console.log(error)
    //   if (notUser(error)) {
    //     setemailerror(true)
    //     setemailerrorText('No se encontró el usuario ingresado')
    //   } else {
    //     setcreateFailure(true)
    //   }
    // }
  }

  return (
    <>
      {createSuccess
        ? (
        <Box
          sx={{
            marginLeft: '5%',
            width: '90%',
            marginTop: '2%'
          }}
        >
          <Typography sx={{ mt: 2, mb: 1 }}>
            Usuario agregado con exito
          </Typography>
          <Box style={{ position: 'absolute', bottom: 20, right: 30 }}>
            <Button
              onClick={() => {
                setStateUserOrganization(false)
              }}
              sx={{ mr: 1 }}
              style={{ backgroundColor: '#026873', color: '#FCFDFD' }}
            >
              CERRAR
            </Button>
          </Box>
        </Box>
          )
        : createFailure
          ? (
        <Box
          sx={{
            marginLeft: '5%',
            width: '90%',
            marginTop: '2%'
          }}
        >
          <Typography sx={{ mt: 2, mb: 1 }}>
            Ocurri&oacute; un error al intentar añadir el usuario.
          </Typography>
          <Typography sx={{ mt: 2, mb: 1 }}>
            Intente refrescar y volver a intentarlo
          </Typography>
          <Box style={{ position: 'absolute', bottom: 20, right: 30 }}>
            <Button
              onClick={() => {
                setStateUserOrganization(false)
              }}
              sx={{ mr: 1 }}
              style={{ backgroundColor: '#026873', color: '#FCFDFD' }}
            >
              CERRAR
            </Button>
          </Box>
        </Box>
            )
          : (
        <Box className={classes.backgroundBox}>
          <Box className={classes.mainBox}>
            <Typography className={classes.addUsertypography}>
              Agregar un usuario a una organizaci&oacute;n
            </Typography>
            <Typography className={classes.instructionsTypography}>
              Ingrese el correo electrónico del usuario que desea agregar a la
              organización:
            </Typography>
            <Typography className={classes.fieldsTypography}>
              Email del usuario
            </Typography>
            <TextField
              sx={{ marginLeft: 1 }}
              variant="outlined"
              required
              id="name"
              name="name"
              value={email}
              onChange={handleUsernChange}
              size="small"
              style={{ width: '90%' }}
              error={emailerror}
              helperText={emailerror ? emailerrorText : null}
            />
            <Typography className={classes.selectTypography}>
              Tipo de usuario:
            </Typography>
            <FormControl
              variant="standard"
              className={classes.formControlStyle}
            >
              <Select
                labelId="demo-simple-select-filled-label"
                id="demo-simple-select-filled"
                value={type}
                onChange={handleChangeType}
                size="small"
              >
                {types.length > 0
                  ? (
                      typesfilter.map((t) => (
                    <MenuItem
                      key={t.organizationUserTypeName}
                      value={t.organizationUserTypeName}
                    >
                      {traducSpanishTypeUser(t.organizationUserTypeName)}
                    </MenuItem>
                      ))
                    )
                  : (
                  <MenuItem value="">
                    No se encontraron tipos de usuarios
                  </MenuItem>
                    )}
              </Select>
            </FormControl>

            <Typography className={classes.selectTypography}>
              Tipo comercial:
            </Typography>
            <FormControl
              variant="standard"
              className={classes.formControlStyle}
            >
              <Select
                labelId="demo-simple-select-filled-label"
                id="demo-simple-select-filled"
                value={typeComercial}
                onChange={handleChangeTypeComercial}
                size="small"
              >
                {typesComercial.length > 0
                  ? (
                      typesComercial.map((t) => (
                    <MenuItem
                      key={t.organizationCommercialUserTypeName}
                      value={t.organizationCommercialUserTypeName}
                    >
                      {t.organizationCommercialUserTypeName}
                    </MenuItem>
                      ))
                    )
                  : (
                  <MenuItem value="">
                    No se encontraron tipos comerciales
                  </MenuItem>
                    )}
              </Select>
            </FormControl>
          </Box>
          <Box className={classes.boxButton}>
            <Box
              className={classes.addUserButton}
              sx={{
                '&:hover': {
                  bgcolor: '#1BF57F'
                }
              }}
            >
              <Typography
                className={classes.addUserButtonTypography}
                onClick={() => {
                  handleAddUserSubmit()
                }}
              >
                Agregar
              </Typography>
            </Box>
            <ButtonCancel setStateUserOrganization={setStateUserOrganization} />
          </Box>
        </Box>
            )}
    </>
  )
}
function ButtonCancel ({ setStateUserOrganization }) {
  const classes = useStylesAddUserInOrganization()
  return (
    <Box className={classes.cancelButton}>
      <Typography
        className={classes.cancelButtonTypography}
        onClick={() => {
          setStateUserOrganization(false)
        }}
        sx={{
          '&:hover': {
            color: '#1BF57F'
          }
        }}
      >
        Cancelar
      </Typography>
    </Box>
  )
}
